import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_INSTALL_STATUS = createAsyncActionTypes('FETCH_INSTALL_STATUS');